import FieldValue from 'domain/entity/preset/field/fieldValue';

export default class PresetField {
    constructor(
        readonly type: string,
        readonly values: FieldValue[],
        readonly maxSelectionLength?: number,
        readonly minSelectionLength?: number
    ) {}
}
